module.exports = __webpack_public_path__ + "img/user.a713c900.png";